import { render } from "./ForecastingPCODashboard.vue?vue&type=template&id=c666aa68&ts=true"
import script from "./ForecastingPCODashboard.vue?vue&type=script&lang=ts"
export * from "./ForecastingPCODashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__